import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { createPortal } from 'react-dom';
import { WithCommonProps } from '@types';
import { usePopout, useClickAway, PopoutPlacement } from '@hooks';
import { twMerge } from 'tailwind-merge';

// UI
import { tooltipContentStylesAsClassName, tooltipStylesAsClassName } from './tooltip-styles';
export enum TooltipPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}
export enum TooltipAlignment {
  START = 'start',
  CENTER = 'center',
  END = 'end',
}
export interface ITooltipProps {
  /** Content to be rendered inside the tooltip */
  children: React.ReactNode;
  /** Indicates the position of the popout */
  placement?: PopoutPlacement;
  /** Indicates whether the Popover is opened */
  isOpen: boolean;
  /** Function to be executed when clicking outside the popover */
  onClickAway?: VoidFunction;
  /** Reference of the element from which the popover is going to be shown */
  reference: HTMLElement | null;
  /** id to reference the tooltip content by accessibility */
  id: string;
}
export const Tooltip: React.FC<WithCommonProps<ITooltipProps>> = t0 => {
  const $ = _c(26);
  let children;
  let classNameProp;
  let id;
  let isOpen;
  let onClickAway;
  let reference;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      placement: t1,
      reference,
      onClickAway,
      isOpen,
      id,
      className: classNameProp,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = classNameProp;
    $[3] = id;
    $[4] = isOpen;
    $[5] = onClickAway;
    $[6] = reference;
    $[7] = rest;
    $[8] = t1;
  } else {
    children = $[1];
    classNameProp = $[2];
    id = $[3];
    isOpen = $[4];
    onClickAway = $[5];
    reference = $[6];
    rest = $[7];
    t1 = $[8];
  }
  const placement = t1 === undefined ? "top" : t1;
  let t2;
  if ($[9] !== isOpen) {
    t2 = {
      enabled: isOpen
    };
    $[9] = isOpen;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const {
    setPopoutElement
  } = usePopout(reference, placement, t2);
  const clickAwayRef = React.useRef(null);
  let t3;
  if ($[11] !== onClickAway) {
    t3 = () => {
      onClickAway?.();
    };
    $[11] = onClickAway;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  useClickAway(clickAwayRef, t3);
  let t4;
  if ($[13] !== setPopoutElement) {
    t4 = element => {
      setPopoutElement(element);
      clickAwayRef.current = element;
    };
    $[13] = setPopoutElement;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const setRef = t4;
  let t5;
  if ($[15] !== classNameProp) {
    t5 = twMerge(tooltipStylesAsClassName, classNameProp);
    $[15] = classNameProp;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const toolTipStylesAndSpacerClassName = t5;
  let t6;
  if ($[17] !== children || $[18] !== id || $[19] !== isOpen || $[20] !== rest || $[21] !== setRef || $[22] !== toolTipStylesAndSpacerClassName) {
    t6 = isOpen && <>{createPortal(<div id={id} role="tooltip" ref={setRef} className={toolTipStylesAndSpacerClassName} {...rest}><div className={tooltipContentStylesAsClassName}>{children}</div></div>, window.document.body)}</>;
    $[17] = children;
    $[18] = id;
    $[19] = isOpen;
    $[20] = rest;
    $[21] = setRef;
    $[22] = toolTipStylesAndSpacerClassName;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t6) {
    t7 = <>{t6}</>;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
};